export enum HrisProvider {
  BambooHr = 'bamboo_hr',
}
